import LocalizedStrings from 'localized-strings';

import { TeamMemberRole, TeamMemberStatus } from '__generated__/GQL';

import { MenuButtonsIds } from './types';

const locales = new LocalizedStrings({
  en: {
    errors: {
      invitationError:
        'Due to a technical issue, we were unable to send the invite. Please try again and do not hesitate to contact us if the problem persists.',
    },
    menu: {
      [MenuButtonsIds.ACCESS_TRANSACTIONS]: 'View transactions',
      [MenuButtonsIds.ACCESS_OWN_TRANSACTIONS]: 'Your transactions',
      [MenuButtonsIds.DELETE_INVITATION]: 'Delete the invitation',
      [MenuButtonsIds.SEND_AGAIN_INVITATION]: 'Send the invitation back',
      [MenuButtonsIds.LOCK_MEMBER]: 'Revoke access',
      [MenuButtonsIds.UNLOCK_MEMBER]: 'Invite again',
      [MenuButtonsIds.TRANSITION_TO_ROLE]: 'Change the role',
    },
    resendInvitationConfirmation:
      'The invitation was successfully sent back to {firstName} {lastName}!',
    role: {
      [TeamMemberRole.AccountHolder]: 'Account holder',
      [TeamMemberRole.Accountant]: 'Accountant',
      [TeamMemberRole.Admin]: 'Admin',
      [TeamMemberRole.Employee]: 'Employee',
      [TeamMemberRole.None]: '',
    },
    status: {
      [TeamMemberStatus.Active]: 'Active',
      [TeamMemberStatus.Locked]: 'Revoked',
      [TeamMemberStatus.InvitationSent]: 'Invitation sent',
      [TeamMemberStatus.ValidationOngoing]: 'Validation in progress',
    },
    title: 'Members',
    unlockConfirmation:
      '{firstName} {lastName}’s access has been successfully restored.',
  },
  fr: {
    errors: {
      invitationError:
        'Suite à une erreur technique, nous n’avons pas pu envoyer l’invitation. Veuillez réessayer et n’hésitez pas à nous contacter si le problème persiste.',
    },
    menu: {
      [MenuButtonsIds.ACCESS_TRANSACTIONS]: 'Voir les transactions',
      [MenuButtonsIds.ACCESS_OWN_TRANSACTIONS]: 'Vos transactions',
      [MenuButtonsIds.DELETE_INVITATION]: 'Supprimer l’invitation',
      [MenuButtonsIds.SEND_AGAIN_INVITATION]: 'Renvoyer l’invitation',
      [MenuButtonsIds.LOCK_MEMBER]: 'Révoquer l’accès',
      [MenuButtonsIds.UNLOCK_MEMBER]: 'Inviter de nouveau',
      [MenuButtonsIds.TRANSITION_TO_ROLE]: 'Modifier le role',
    },
    resendInvitationConfirmation:
      'L’invitation a bien été renvoyée à {firstName} {lastName}\xA0!',
    role: {
      [TeamMemberRole.AccountHolder]: 'Titulaire du compte',
      [TeamMemberRole.Accountant]: 'Comptable',
      [TeamMemberRole.Admin]: 'Admin',
      [TeamMemberRole.Employee]: 'Employé·e',
      [TeamMemberRole.None]: '',
    },
    status: {
      [TeamMemberStatus.Active]: 'Actif',
      [TeamMemberStatus.Locked]: 'Révoqué·e',
      [TeamMemberStatus.InvitationSent]: 'Invitation envoyée',
      [TeamMemberStatus.ValidationOngoing]: 'En cours de validation',
    },
    title: 'Membres',
    unlockConfirmation:
      'Les accès de {firstName} {lastName} ont bien été rétablis.',
  },
} as const);

export default locales;
